import { __rest } from 'tslib';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useForTablet, useForBigScreen, SidebarLayout } from '@sketch/components';
import '../../routes/index.js';
import '../../browser/index.js';
import { useLayoutOverrideProps, useLayoutPortal } from '@sketch/utils';
import { useBrowserSettings } from '../../browser/useBrowserSettings.js';
import { isCwvRouteOnly } from '../../routes/utils/paths.js';

const DocumentSidebarLayout = (_a) => {
    var props = __rest(_a, []);
    const { render, component: Component, title: initialTitle } = props, rest = __rest(props, ["render", "component", "title"]);
    const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
    const isTabletAndBigger = useForTablet();
    const isDesktopAndBigger = useForBigScreen();
    const toggleMobileSidebar = () => setIsMobileSidebarOpen(isOpen => !isOpen);
    const [data, updateBrowserSettings] = useBrowserSettings();
    const isSidebarRightOpen = data === null || data === void 0 ? void 0 : data.sidebarRightOpen;
    // For Components Web View pages on tablet we hide the sidebar because we
    // prioritise the left menu sidebar
    const { path } = useRouteMatch();
    const shouldHideRightSidebar = isTabletAndBigger && !isDesktopAndBigger && isCwvRouteOnly(path);
    const toggleSidebarRight = () => {
        updateBrowserSettings({
            sidebarRightOpen: !isSidebarRightOpen,
        });
    };
    useEffect(() => {
        if (isSidebarRightOpen && shouldHideRightSidebar) {
            toggleSidebarRight === null || toggleSidebarRight === void 0 ? void 0 : toggleSidebarRight();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const isOpen = isTabletAndBigger ? isSidebarRightOpen : isMobileSidebarOpen;
    const toggle = isTabletAndBigger ? toggleSidebarRight : toggleMobileSidebar;
    // Layout hooks
    const { getOverriddenProps, useOverrideLayoutProps, } = useLayoutOverrideProps();
    const { title } = getOverriddenProps({
        title: initialTitle,
    });
    const [HeaderPortal, setHeaderPortalContainerRef] = useLayoutPortal();
    const [SidebarLeftPortal, setSidebarLeftPortalContainerRef,] = useLayoutPortal();
    const [SidebarRightPortal, setSidebarRightPortalContainerRef,] = useLayoutPortal();
    const [FooterPortal, setFooterPortalContainerRef] = useLayoutPortal();
    const childrenProps = {
        HeaderPortal,
        SidebarLeftPortal,
        SidebarRightPortal,
        FooterPortal,
        useOverrideLayoutProps,
    };
    return (jsx(SidebarLayout, Object.assign({ isSidebarRightOpen: isOpen, toggleSidebarRight: toggle, title: title, header: jsx("div", { ref: ref => setHeaderPortalContainerRef(ref) }), sidebarLeft: jsx("div", { ref: ref => setSidebarLeftPortalContainerRef(ref) }), sidebarRight: jsx("div", { ref: ref => setSidebarRightPortalContainerRef(ref) }), footer: jsx("div", { ref: ref => setFooterPortalContainerRef(ref) }) }, rest, { children: (sidebarLayoutProps) => (jsxs(Fragment, { children: [render &&
                    render(Object.assign(Object.assign({}, childrenProps), sidebarLayoutProps)), Component && (jsx(Component, Object.assign({}, childrenProps, sidebarLayoutProps)))] })) })));
};

export { DocumentSidebarLayout };
